import {Article} from "./article";
import {PricingItem} from "./pricing-item";

export class PackPricingItem extends PricingItem{
    public device?: Article;

}
